import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import QRCodeStyling from 'qr-code-styling';
import { GetParamObject, ValidUrl } from '../../util/util';
import { GetXconfig } from '../../api/db/mysqldb';

export const QrInstant = (props: { match: any; location: any }) => {
  const [isLoaded, setLoaded] = useState(false);
  const ref: any = useRef(null);

  var query = GetParamObject(props.location.search);

  if (query?.url && query?.customer && ValidUrl(query.url)) {
    useEffect(() => {
      async function CreateQrCode(params: any) {
        try {
          if (params?.url && params?.customer && params?.pwd) {
            const req = await fetch(
              '/style?pwd=' +
                params.pwd +
                '&customer=' +
                params.customer +
                '&product=' +
                params.product,
              {
                method: 'GET',
                headers: { 'content-type': 'application/json' },
              }
            );

            const json = await req.json();

            if (json && json?.success && json?.data) {
              if (params?.width > 0) json.data.width = params.width;

              if (params?.height > 0) json.data.height = params.height;

              await AppendStyleData(params.url, json.data, params.download);
            }
          }
        } catch {}
      }

      async function AppendStyleData(url: any, json: any, download: any) {
        if (json && url) {
          const qrdata = new QRCodeStyling(json);

          if (qrdata) {
            setLoaded(true);
            qrdata.append(ref.current);
            qrdata.update({ data: url });

            //var blob = await qrdata.getRawData();
            //var array = await blob?.arrayBuffer();
            //console.log(array);

            if (download == true) {
              qrdata.download({
                extension: 'png',
              });
            }
          }
        }
      }

      try {
        const params = {
          url: query.url,
          customer: query.customer,
          product: query.product,
          pwd: query.pwd,
          width: query?.width && !isNaN(query.width) ? Number(query.width) : 0,
          height:
            query?.height && !isNaN(query.height) ? Number(query.height) : 0,
          download: query?.download ? query.download == 'true' : false,
        };

        if (params.width > 0 && params.height < 1) {
          params.height = params.width;
        }

        if (params.width < 1 && params.height > 0) {
          params.width = params.height;
        }

        CreateQrCode(params);
      } catch {}
    }, []);
  }

  return <> {!isLoaded ? null : <div ref={ref} />}</>;
};
